<template>
  <v-dialog :value="value" @input="handleDialogInput" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        {{ $t("ARCHIVE_ROUTE_MAP_CONFIRMATION") }}
      </v-card-title>

      <v-card-text>
        <ErrorMessages :errorMessages="localErrorMessages" />

        {{ $t("NOTE") }} (BG):
        <textarea v-model="note" class="form-control mb-3"></textarea>

        {{ $t("NOTE") }} (EN):
        <textarea v-model="noteEn" class="form-control"></textarea>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text>
          <span
            class="btn btn-danger btn-block"
            @click="$emit('cancel-clicked')"
          >
            {{ $t("CANCEL") }}
          </span>
        </v-btn>
        <v-btn text>
          <span class="btn btn-success btn-block" @click="handleArchiveClicked">
            {{ $t("ARCHIVE") }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ErrorMessages from "@/components/ErrorMessages";
import { DELETE_ROUTEMAP } from "@/store/routemaps.module";

export default {
  components: {
    ErrorMessages,
  },

  props: {
    value: {
      required: true,
      type: Boolean,
    },

    archivingId: {
      required: true,
    },

    archivingName: {
      required: true,
    },

    errorMessages: {
      default: () => {},
    },
  },

  data() {
    return {
      note: "",
      noteEn: "",
      localErrorMessages: {},
    };
  },

  watch: {
    value() {
      this.note = "";
      this.noteEn = "";
      this.localErrorMessages = {};
    },

    errorMessages() {
      this.localErrorMessages = this.errorMessages;
    },
  },

  methods: {
    handleArchiveClicked() {
      if (!this.note || !this.noteEn) {
        this.localErrorMessages = {
          0: [this.$t("THE_FIELD_NOTE_IS_REQUIRED")],
        };

        return;
      }

      let vm = this;

      vm.$confirm({
        title: `${vm.$t("ARCHIVE_CONFIRMATION")} ${vm.archivingName}?`,
        content: vm.$t("ARCHIVE_CONFIRMATION_DESCRIPTION"),
        icon: "warning",
        okText: vm.$t("OK_TEXT"),
        cancelText: vm.$t("CANCEL_TEXT"),
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        onOk() {
          vm.archive();
        },
        onCancel() {},
      });
    },

    archive() {
      let vm = this;

      vm.$store
        .dispatch(DELETE_ROUTEMAP, { id: vm.archivingId, note: vm.note, noteEn: vm.noteEn })
        .then((data) => {
          vm.$notification["success"]({
            message: data.status,
            description: data.message,
          });

          vm.$emit("archived");

          vm.localErrorMessages = [];
        })
        .catch((errors) => {
          if (errors.data.errors.note) {
            vm.localErrorMessages = Object.values(errors.data.errors);
          }
        });
    },

    handleDialogInput(value) {
      this.note = "";
      this.noteEn = "";
      this.localErrorMessages = {};

      this.$emit("input", value);
    },
  },
};
</script>
